<template>
  <div class="navbar-mobile-menu-backdrop">

    <NavbarMobileHeader
      @close="$emit('close')"
      theme="blue"
    />

    <div class="navbar-mobile-tabs">
      <div 
        @click="activeTab = 'sections'"
        class="navbar-mobile-tab"
        :class="{ 'navbar-mobile-tab--active': activeTab === 'sections' }"
      >
        {{ $t("navbar.sections") }}
      </div>
      <div 
        @click="activeTab = 'account'"
        class="navbar-mobile-tab"
        :class="{ 'navbar-mobile-tab--active': activeTab === 'account' }"
      >
        {{ $t("navbar.my_account") }}
      </div>
      <div 
        @click="activeTab = 'search'"
        class="navbar-mobile-tab"
        :class="{ 'navbar-mobile-tab--active': activeTab === 'search' }"
      >
        {{ $t("navbar.search") }}
      </div>
    </div>

    <div class="navbar-mobile-menu-wrapper">
      <div class="navbar-mobile-menu">
        <div v-if="activeTab === 'sections'" class="navbar-mobile-menu-content">
        <div class="navbar-mobile-accordion">
          <div 
            @click="toggleSection('fly')"
            class="navbar-mobile-accordion-header"
          >
            <span class="navbar-mobile-menu-item">{{ $t("navbar.fly") }}</span>
            <svg class="navbar-mobile-accordion-chevron" :class="{ 'navbar-mobile-accordion-chevron--open': expandedSection === 'fly' }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" fill-rule="evenodd" d="m14.39 5.642-5.703 5.677H7.295L1.614 5.642l.712-.7 5.385 5.377h.564l5.4-5.378z"></path>
            </svg>
          </div>
          <transition name="accordion">
            <div v-if="expandedSection === 'fly'" class="navbar-mobile-accordion-content">
              <div class="navbar-mobile-accordion-first-row">
                <div
                  @click="goToPage('fly')"
                  class="navbar-mobile-accordion-item"
                >
                  {{ $t('category.Show All') }}
                </div>
                <div
                  @click="goToPageWithLiked('fly')"
                  class="navbar-mobile-accordion-item"
                >
                  {{ $t('category.Liked Only') }}
                </div>
              </div>
              <div
                v-for="category in flyCategories"
                :key="category.id"
                @click="goToFlyPageWithCategory(category.name)"
                class="navbar-mobile-accordion-item"
              >
                {{ $t(`category.${category.name}`) }}
              </div>
            </div>
          </transition>
        </div>

        <div class="navbar-mobile-accordion">
          <div 
            @click="toggleSection('learn')"
            class="navbar-mobile-accordion-header"
          >
            <span class="navbar-mobile-menu-item">{{ $t("navbar.learn") }}</span>
            <svg class="navbar-mobile-accordion-chevron" :class="{ 'navbar-mobile-accordion-chevron--open': expandedSection === 'learn' }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" fill-rule="evenodd" d="m14.39 5.642-5.703 5.677H7.295L1.614 5.642l.712-.7 5.385 5.377h.564l5.4-5.378z"></path>
            </svg>
          </div>
          <transition name="accordion">
            <div v-if="expandedSection === 'learn'" class="navbar-mobile-accordion-content">
              <div class="navbar-mobile-accordion-first-row">
                <div
                  @click="goToPage('learn')"
                  class="navbar-mobile-accordion-item"
                >
                  {{ $t('category.Show All') }}
                </div>
                <div
                  @click="goToPageWithLiked('learn')"
                  class="navbar-mobile-accordion-item"
                >
                  {{ $t('category.Liked Only') }}
                </div>
              </div>
              <div
                v-for="(category, index) in learnCategories"
                :key="index"
                @click="goToPageWithCategory('learn', category)"
                class="navbar-mobile-accordion-item"
              >
                {{ category }}
              </div>
            </div>
          </transition>
        </div>

        <div class="navbar-mobile-accordion">
          <div 
            @click="toggleSection('map')"
            class="navbar-mobile-accordion-header"
          >
            <span class="navbar-mobile-menu-item">{{ $t("navbar.map") }}</span>
            <svg class="navbar-mobile-accordion-chevron" :class="{ 'navbar-mobile-accordion-chevron--open': expandedSection === 'map' }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" fill-rule="evenodd" d="m14.39 5.642-5.703 5.677H7.295L1.614 5.642l.712-.7 5.385 5.377h.564l5.4-5.378z"></path>
            </svg>
          </div>
          <transition name="accordion">
            <div v-if="expandedSection === 'map'" class="navbar-mobile-accordion-content">
              <div
                @click="goToPage('map')"
                class="navbar-mobile-accordion-item"
              >
                {{ $t('category.Show All') }}
              </div>
              <div
                v-for="category in mapCategories"
                :key="category.id"
                @click="goToPageWithCategory('map', category.id)"
                class="navbar-mobile-accordion-item"
              >
                {{ $t(`category.${category.name}`) }}
              </div>
            </div>
          </transition>
        </div>

        <div class="navbar-mobile-accordion">
          <div 
            @click="toggleSection('hub')"
            class="navbar-mobile-accordion-header"
          >
            <span class="navbar-mobile-menu-item">{{ $t("navbar.hub") }}</span>
            <svg class="navbar-mobile-accordion-chevron" :class="{ 'navbar-mobile-accordion-chevron--open': expandedSection === 'hub' }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" fill-rule="evenodd" d="m14.39 5.642-5.703 5.677H7.295L1.614 5.642l.712-.7 5.385 5.377h.564l5.4-5.378z"></path>
            </svg>
          </div>
          <transition name="accordion">
            <div v-if="expandedSection === 'hub'" class="navbar-mobile-accordion-content navbar-mobile-accordion-content--single-column">
              <div
                @click="goToPage('hub')"
                class="navbar-mobile-accordion-item"
              >
                {{ $t('category.Show All') }}
              </div>

              <div class="navbar-mobile-subaccordion">
                <div
                  @click="toggleSubSection('hub-ads')"
                  class="navbar-mobile-subaccordion-header"
                >
                  <span class="navbar-mobile-accordion-item">{{ $t('navbar.ads_only') }}</span>
                  <svg class="navbar-mobile-accordion-chevron navbar-mobile-accordion-chevron--small" :class="{ 'navbar-mobile-accordion-chevron--open': expandedSubSection === 'hub-ads' }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" fill-rule="evenodd" d="m14.39 5.642-5.703 5.677H7.295L1.614 5.642l.712-.7 5.385 5.377h.564l5.4-5.378z"></path>
                  </svg>
                </div>
                <transition name="accordion">
                  <div v-if="expandedSubSection === 'hub-ads'" class="navbar-mobile-subaccordion-content">
                    <div
                      @click="goToAdsList()"
                      class="navbar-mobile-accordion-item"
                    >
                      {{ $t('category.Show All') }}
                    </div>
                    <div
                      v-for="category in adsCategories"
                      :key="category.id"
                      @click="goToPageWithCategory('hub/ads', category.id)"
                      class="navbar-mobile-accordion-item"
                    >
                      {{ $t(`category.${category.name}`) }}
                    </div>
                  </div>
                </transition>
              </div>

              <div
                @click="goToPage('news')"
                class="navbar-mobile-accordion-item"
              >
                {{ $t('navbar.news_only') }}
              </div>
              <div
                @click="goToHubEvents"
                class="navbar-mobile-accordion-item"
              >
                {{ $t('navbar.events_only') }}
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div v-if="activeTab === 'account'" class="navbar-mobile-menu-content">
        <div class="navbar-mobile-accordion">
          <div 
            @click="toggleSection('airspirit')"
            class="navbar-mobile-accordion-header"
          >
            <span class="navbar-mobile-menu-item">AIRspirit</span>
            <svg class="navbar-mobile-accordion-chevron" :class="{ 'navbar-mobile-accordion-chevron--open': expandedSection === 'airspirit' }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" fill-rule="evenodd" d="m14.39 5.642-5.703 5.677H7.295L1.614 5.642l.712-.7 5.385 5.377h.564l5.4-5.378z"></path>
            </svg>
          </div>
          <transition name="accordion">
            <div v-if="expandedSection === 'airspirit'" class="navbar-mobile-accordion-content navbar-mobile-accordion-content--single-column">
              <div
                @click="goToPage('who-we-are')"
                class="navbar-mobile-accordion-item"
              >
                {{$t('footer.who_we_are')}}
              </div>
              <div
                @click="goToPage('about-features')"
                class="navbar-mobile-accordion-item"
              >
                {{$t('footer.how_airspirit_works')}}
              </div>
            </div>
          </transition>
        </div>

        <div class="navbar-mobile-accordion">
          <div 
            @click="toggleSection('community')"
            class="navbar-mobile-accordion-header"
          >
            <span class="navbar-mobile-menu-item">{{$t('footer.community')}}</span>
            <svg class="navbar-mobile-accordion-chevron" :class="{ 'navbar-mobile-accordion-chevron--open': expandedSection === 'community' }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" fill-rule="evenodd" d="m14.39 5.642-5.703 5.677H7.295L1.614 5.642l.712-.7 5.385 5.377h.564l5.4-5.378z"></path>
            </svg>
          </div>
          <transition name="accordion">
            <div v-if="expandedSection === 'community'" class="navbar-mobile-accordion-content navbar-mobile-accordion-content--single-column">
              <div
                @click="contactUs"
                class="navbar-mobile-accordion-item"
              >
                {{$t('footer.contact_us')}}
              </div>
              <div
                @click="donate"
                class="navbar-mobile-accordion-item"
              >
                {{$t('footer.donate_to_airspirit')}}
              </div>
            </div>
          </transition>
        </div>

        <div class="navbar-mobile-accordion">
          <div 
            @click="toggleSection('business')"
            class="navbar-mobile-accordion-header"
          >
            <span class="navbar-mobile-menu-item">{{$t('footer.do_business_with_us')}}</span>
            <svg class="navbar-mobile-accordion-chevron" :class="{ 'navbar-mobile-accordion-chevron--open': expandedSection === 'business' }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" fill-rule="evenodd" d="m14.39 5.642-5.703 5.677H7.295L1.614 5.642l.712-.7 5.385 5.377h.564l5.4-5.378z"></path>
            </svg>
          </div>
          <transition name="accordion">
            <div v-if="expandedSection === 'business'" class="navbar-mobile-accordion-content navbar-mobile-accordion-content--single-column">
              <div
                @click="registerAsIndividual"
                class="navbar-mobile-accordion-item"
              >
                {{$t('footer.register_as_individual')}}
              </div>
              <div
                @click="registerBusiness"
                class="navbar-mobile-accordion-item"
              >
                {{$t('footer.register_your_business')}}
              </div>
            </div>
          </transition>
        </div>

        <div class="navbar-mobile-accordion">
          <div 
            @click="toggleSection('support')"
            class="navbar-mobile-accordion-header"
          >
            <span class="navbar-mobile-menu-item">{{$t('footer.support_and_ressources')}}</span>
            <svg class="navbar-mobile-accordion-chevron" :class="{ 'navbar-mobile-accordion-chevron--open': expandedSection === 'support' }" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" fill-rule="evenodd" d="m14.39 5.642-5.703 5.677H7.295L1.614 5.642l.712-.7 5.385 5.377h.564l5.4-5.378z"></path>
            </svg>
          </div>
          <transition name="accordion">
            <div v-if="expandedSection === 'support'" class="navbar-mobile-accordion-content navbar-mobile-accordion-content--single-column">
              <div
                @click="goToPage('privacy')"
                class="navbar-mobile-accordion-item"
              >
                {{$t('footer.privacy_policy')}}
              </div>
              <div
                @click="goToPage('terms')"
                class="navbar-mobile-accordion-item"
              >
                {{$t('footer.terms_of_service')}}
              </div>
            </div>
          </transition>
        </div>

        <div v-if="!isAuthenticated" class="navbar-mobile-login-section">
          <input
            v-model="loginEmail"
            class="navbar-mobile-login-input"
            type="email"
            :placeholder="$t('navbar.email_placeholder')"
          />
          <input
            v-model="loginPassword"
            class="navbar-mobile-login-input"
            type="password"
            :placeholder="$t('navbar.password_placeholder')"
            @keyup.enter="login"
          />
          <div v-if="loginError" class="navbar-mobile-login-error">
            {{ loginError }}
          </div>
          <button
            @click="login"
            class="navbar-mobile-login-button"
          >
            {{ $t('navbar.log_in') }}
          </button>
        </div>

        <div v-if="isAuthenticated" class="navbar-mobile-logout-section">
          <button
            @click="goToAccount"
            class="navbar-mobile-manage-account-button"
          >
            {{ $t('navbar.manage_my_account') }}
          </button>
          <button
            @click="logout"
            class="navbar-mobile-logout-button"
          >
            {{ $t('navbar.log_out') }}
          </button>
        </div>
      </div>

      <div v-if="activeTab === 'search'" class="navbar-mobile-menu-content">
        <div class="navbar-mobile-search-input-container">
          <input
            v-model="searchText"
            class="navbar-mobile-search-input"
            type="text"
            :placeholder="$t('navbar.search_placeholder_mobile')"
          />
        </div>
        <div class="navbar-mobile-search-buttons-grid">
          <div
            @click="searchOn('/fly')"
            class="navbar-mobile-search-button"
          >
            {{ $t('navbar.search_fly') }}
          </div>
          <div
            @click="searchOn('/hub/ads')"
            class="navbar-mobile-search-button"
          >
            {{ $t('navbar.search_ads') }}
          </div>
          <div
            @click="searchOn('/news')"
            class="navbar-mobile-search-button"
          >
            {{ $t('navbar.search_news') }}
          </div>
          <div
            @click="searchOn('/learn')"
            class="navbar-mobile-search-button"
          >
            {{ $t('navbar.search_learn') }}
          </div>
        </div>
        <div class="navbar-mobile-search-divider">
          {{ $t('navbar.or') }}
        </div>
        <button
          @click="messageAirspirit"
          class="navbar-mobile-search-message-button"
        >
          {{ $t('navbar.message_airspirit') }}
        </button>
        <div class="navbar-mobile-search-disclaimer">
          {{ $t('navbar.message_disclaimer') }}
        </div>
      </div>

      <div class="navbar-mobile-language">
        <img 
          @click="$emit('open-language-modal')"
          class="navbar-mobile-language-icon"
          src="@/assets/images/navbar/languages_white.svg" 
          alt="languages" 
        />
      </div>

      <div class="navbar-mobile-footer">
        AIRspirit &copy; {{currentYear}}
      </div>
      </div>
    </div>
  </div>
</template>

<script>

import NavbarMobileHeader from '@/components/navbar/NavbarMobileHeader.vue'
import { userMixins } from '@/mixins/userMixins'
import { APICategory } from '@/api/APICategory'

const apiCategory = new APICategory()

export default {
  components: { NavbarMobileHeader },
  name: 'NavbarMobileMenu',
  mixins: [userMixins],
  data() {
    return {
      activeTab: 'sections',
      searchText: '',
      expandedSection: null,
      expandedSubSection: null,
      adsCategories: [],
      flyCategories: [],
      mapCategories: [],
      learnCategories: [
        'Recreational Pilot',
        'Professional Pilot',
        'Commercial Crew',
        'Aircraft Mechanic',
        'Drone Operator',
        'Engineering',
        'Traffic Controller',
      ],
      loginEmail: '',
      loginPassword: '',
      loginError: ''
    }
  },
  async mounted() {
    await this.loadCategories()
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    userFirstName() {
      return this.$store.getters.getUserFirstName
    },
    userLastName() {
      return this.$store.getters.getUserLastName
    }
  },
  methods: {
    async loadCategories() {
      try {
        const adsResult = await apiCategory.getCategories('ad')
        this.adsCategories = adsResult.data.filter(cat => cat.color)

        const flyResult = await apiCategory.getCategories('flight')
        this.flyCategories = flyResult.data.filter(cat => cat.color)

        const mapResult = await apiCategory.getCategories('map')
        this.mapCategories = mapResult.data.filter(cat => cat.color)
      } catch (error) {
        console.error('Error loading categories:', error)
      }
    },
    toggleSection(section) {
      this.expandedSubSection = null
      if (this.expandedSection === section) {
        this.expandedSection = null
      } else {
        this.expandedSection = section
      }
    },
    toggleSubSection(subSection) {
      if (this.expandedSubSection === subSection) {
        this.expandedSubSection = null
      } else {
        this.expandedSubSection = subSection
      }
    },
    closeModal() {
      this.$emit('close');
    },
    goToPage(page) {
      this.$emit('close');
      this.$router.push(`/${page}`);
    },
    goToPageWithCategory(page, categoryId) {
      this.$emit('close');
      const currentRoute = this.$route.path;
      const targetRoute = `/${page}`;
      
      if (currentRoute === targetRoute) {
        // If already on the page, use window.location to force reload with new category
        window.location.href = `${targetRoute}?categories=${categoryId}`;
      } else {
        const query = { categories: categoryId }
        this.$router.push({ path: targetRoute, query })
      }
    },
    goToFlyPageWithCategory(categoryName) {
      this.$emit('close');
      const targetRoute = '/fly';
      if (this.$route.path === targetRoute) {
        window.location.href = `${targetRoute}?category=${encodeURIComponent(categoryName)}`;
      } else {
        this.$router.push({ path: targetRoute, query: { category: categoryName } });
      }
    },
    goToAdsList() {
      this.$emit('close');
      const targetRoute = '/hub/ads';

      if (this.$route.path === targetRoute) {
        // If already on the ads list, force reload to clear the category filter
        window.location.href = targetRoute;
      } else {
        this.$router.push(targetRoute);
      }
    },
    goToHubEvents() {
      this.$emit('close');
      const targetRoute = '/hub';

      if (this.$route.path === targetRoute) {
        // Already on the hub, just open the upcoming events modal
        this.$eventHub.$emit('openHubEventsModal');
      } else {
        this.$router.push({ path: targetRoute, query: { events: 'true' } });
      }
    },
    goToPageWithLiked(page) {
      this.$emit('close');
      const targetRoute = `/${page}`;
      
      if (!this.isAuthenticated) {
        this.$store.commit('set', ['loginModalNotRedirect', true]);
        this.$store.commit('openLoginModal');
        return;
      }
      
      // Navigate to the page with liked filter
      // The page should handle the onlyLiked state
      this.$router.push({ path: targetRoute, query: { liked: 'true' } });
    },
    searchOn(path) {
      if (this.searchText.trim()) {
        this.$store.commit('set', ['searchText', this.searchText]);
        this.$store.commit('set', ['search', this.searchText]);
        this.$emit('close');
        if (this.$route.path !== path) {
          this.$router.push(path);
        }
        setTimeout(() => {
          this.$eventHub.$emit('search');
        }, 100);
      }
    },
    contactUs() {
      window.location.href = 'mailto:info@airspirit.com';
    },
    donate() {
      this.$store.commit('openDonationModal');
      this.$emit('close');
    },
    registerAsIndividual() {
      this.$emit('close');
      this.$router.push('/private-person/registration');
    },
    registerBusiness() {
      this.$emit('close');
      if (!this.isAuthenticated) {
        this.$router.push('/company/registration/category');
      } else {
        if (this.userGroupContains(['COMPANY'])) {
          this.$router.push('/account/');
        } else {
          this.$router.push('/company/registration/category');
        }
      }
    },
    messageAirspirit() {
      const message = this.searchText.trim() || this.$t('navbar.default_contact_message');
      this.$store.commit('set', ['chatInitialMessage', message]);
      this.$emit('close');
      this.$router.push('/chat');
    },
    login() {
      if (!this.loginEmail || !this.loginPassword) {
        this.loginError = this.$t('navbar.enter_email_password');
        return;
      }
      this.loginError = '';
      const credentials = {
        username: this.loginEmail,
        password: this.loginPassword
      };
      this.$store.dispatch('AUTH_REQUEST', credentials)
        .then(() => {
          this.loginEmail = '';
          this.loginPassword = '';
          this.$emit('close');
          this.$router.push('/account');
        })
        .catch(() => {
          this.loginError = this.$t('navbar.incorrect_credentials');
        });
    },
    goToAccount() {
      this.$emit('close');
      this.$router.push('/account');
    },
    logout() {
      this.$store.dispatch('AUTH_LOGOUT')
        .then(() => {
          this.$emit('close');
          this.$router.push('/');
        });
    }
  },
};
</script>

<style>

.navbar-mobile-menu-backdrop {
  background-color: #4179af;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.navbar-mobile-tabs {
  display: flex;
  justify-content: space-around;
  background-color: #4179af;
  gap: 6px;
  padding: 8px 4%;
  flex-shrink: 0;
}

.navbar-mobile-tab {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  font-size: clamp(0.8em, 3.2vw, 0.95em);
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  transition: all 0.25s ease;
  flex: 1;
  text-align: center;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.08);
}

.navbar-mobile-tab--active {
  color: #4179af;
  font-weight: bold;
  background-color: white;
  text-decoration: none;
}

.navbar-mobile-menu-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.navbar-mobile-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 100%;
}

.navbar-mobile-menu-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0 20px;
  flex: 1;
}

.navbar-mobile-login-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-top: 20px;
}

.navbar-mobile-login-input {
  width: 100%;
  padding: 8px 15px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  background-color: white;
  color: #333;
  font-size: 0.95em;
  outline: none;
}

.navbar-mobile-login-input::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-mobile-login-button {
  background-color: white;
  border: none;
  border-radius: 20px;
  color: #4179af;
  padding: 8px 25px;
  font-weight: bold;
  font-size: 0.95em;
  cursor: pointer;
  transition: opacity 0.2s ease;
  width: 120px;
}

.navbar-mobile-login-button:active {
  opacity: 0.7;
}

.navbar-mobile-login-error {
  color: #ff6b6b;
  font-size: 0.9em;
  text-align: center;
  width: 100%;
  font-weight: 500;
}

.navbar-mobile-logout-section {
  width: 100%;
  max-width: 300px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.navbar-mobile-manage-account-button {
  background-color: white;
  border: none;
  border-radius: 20px;
  color: #4179af;
  padding: 8px 25px;
  font-weight: bold;
  font-size: 0.95em;
  cursor: pointer;
  transition: opacity 0.2s ease;
  width: 100%;
}

.navbar-mobile-manage-account-button:active {
  opacity: 0.7;
}

.navbar-mobile-logout-button {
  background-color: white;
  border: none;
  border-radius: 20px;
  color: #4179af;
  padding: 8px 25px;
  font-weight: bold;
  font-size: 0.95em;
  cursor: pointer;
  transition: opacity 0.2s ease;
  width: 100%;
}

.navbar-mobile-logout-button:active {
  opacity: 0.7;
}

.navbar-mobile-accordion {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.navbar-mobile-accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 14px 2px;
  width: 100%;
  min-height: 44px;
}

.navbar-mobile-accordion-chevron {
  color: white;
  width: 16px;
  height: 16px;
  transition: transform 0.5s ease;
  transform: rotate(0deg);
  display: flex;
  align-items: center;
}

.navbar-mobile-accordion-chevron--open {
  transform: rotate(180deg);
}

.accordion-enter-active {
  animation: accordion-open 0.5s ease-out;
  overflow: hidden;
}

.accordion-leave-active {
  animation: accordion-close 0.3s ease-out;
  overflow: hidden;
}

@keyframes accordion-open {
  0% {
    max-height: 0;
    opacity: 0;
  }
  100% {
    max-height: 500px;
    opacity: 1;
  }
}

@keyframes accordion-close {
  0% {
    max-height: 500px;
    opacity: 1;
  }
  100% {
    max-height: 0;
    opacity: 0;
  }
}

.navbar-mobile-accordion-content {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 15px;
  padding-bottom: 15px;
}

.navbar-mobile-accordion-content--single-column {
  grid-template-columns: 1fr;
}

.navbar-mobile-accordion-first-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 15px;
  grid-column: 1 / -1;
}

.navbar-mobile-subaccordion {
  width: 100%;
}

.navbar-mobile-subaccordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
  min-height: 28px;
}

.navbar-mobile-subaccordion-content {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 15px;
  padding: 10px 0 5px 15px;
}

.navbar-mobile-accordion-chevron--small {
  width: 13px;
  height: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.navbar-mobile-accordion-item {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9em;
  cursor: pointer;
  transition: opacity 0.2s ease;
  padding: 4px 0;
  min-height: 28px;
}

.navbar-mobile-accordion-item:active {
  opacity: 0.6;
}

.navbar-mobile-menu-item {
  font-weight: bold;
  color: white;
  font-size: clamp(1.05em, 4.2vw, 1.3em);
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.navbar-mobile-menu-item:active {
  opacity: 0.7;
}

.navbar-mobile-menu-item--smaller {
  font-size: 0.85em;
  font-weight: normal;
}

.navbar-mobile-search-input-container {
  width: 100%;
  max-width: 300px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.navbar-mobile-search-disclaimer {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.7em;
  text-align: center;
  max-width: 300px;
  margin-top: 15px;
  margin-bottom: 0;
  line-height: 1.3;
}

.navbar-mobile-search-buttons-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 20px 15px;
  width: 100%;
  max-width: 300px;
}

.navbar-mobile-search-button {
  color: white;
  font-size: 0.95em;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  padding: 10px 10px;
  min-height: 36px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.1);
  transition: opacity 0.2s ease;
}

.navbar-mobile-search-button:active {
  opacity: 0.7;
}

.navbar-mobile-search-divider {
  color: white;
  font-size: 1em;
  text-align: center;
  margin: 20px 0;
}

.navbar-mobile-search-message-button {
  background-color: white;
  border: none;
  border-radius: 25px;
  color: #4179af;
  padding: 12px 30px;
  font-weight: bold;
  font-size: 1em;
  cursor: pointer;
  transition: opacity 0.2s ease;
  margin-top: 0;
}

.navbar-mobile-search-message-button:active {
  opacity: 0.7;
}

.navbar-mobile-search-input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  background-color: white;
  color: #333;
  font-size: 1em;
  outline: none;
}

.navbar-mobile-search-input::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-mobile-button {
  background-color: white;
  border: unset;
  border-radius: 50px;
  color: #4179af;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  padding-right: 15px;
  font-weight: bold;
}

.navbar-mobile-footer {
  background-color: #4179af;
  color: white;
  text-align: center;
  padding-top: 10px;
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  font-size: 0.7em;
  width: 100%;
}

.navbar-mobile-language {
  background-color: #4179af;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 10px;
  width: 100%;
  margin-top: auto;
  flex-shrink: 0;
}

.navbar-mobile-language-icon {
  width: 25px;
  height: 25px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.navbar-mobile-language-icon:active {
  opacity: 1;
}
</style>